import React, { useRef, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Custom arrow components – small orange circles with icon only
const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <button
      type="button"
      className="slick-arrow slick-prev"
      onClick={onClick}
      aria-label="Previous"
      style={{
        width: 32,
        height: 32,
        background: '#e86b24',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: 'none',
        cursor: 'pointer',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        left: -40,
        zIndex: 2,
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
        transition: 'background 0.3s, transform 0.3s',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = '#d2551a';
        e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = '#e86b24';
        e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
      }}
    >
      <i className="fal fa-chevron-left" style={{ color: '#fff', fontSize: '1rem' }}></i>
    </button>
  );
};

const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <button
      type="button"
      className="slick-arrow slick-next"
      onClick={onClick}
      aria-label="Next"
      style={{
        width: 32,
        height: 32,
        background: '#e86b24',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: 'none',
        cursor: 'pointer',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        right: -40,
        zIndex: 2,
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
        transition: 'background 0.3s, transform 0.3s',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = '#d2551a';
        e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = '#e86b24';
        e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
      }}
    >
      <i className="fal fa-chevron-right" style={{ color: '#fff', fontSize: '1rem' }}></i>
    </button>
  );
};

const teamMembers = [
  { name: "Alhaji Ali Nuhu", role: "Managing Director/CEO", img: "assets/img/team/alinuhu.png" },
  { name: "Salihu Aliyu Maitasamu", role: "General Manager", img: "/assets/img/salihu.png" },
  { name: "Engr. Chukwunonso Obi", role: "Head of Engineering", img: "/assets/img/obi.png" },
  { name: "Roseline Nwabundu", role: "Head of Operations", img: "/assets/img/rose.png" },
  { name: "Usman Abdullahi", role: "Chief Financial Officer", img: "/assets/img/Usman.png" },
  { name: "Aisha Ali Tahir, Esq.", role: "Head of Legal", img: "/assets/img/Aisha.png" },
  { name: "Justin Millicent", role: "Human Resources Manager", img: "/assets/img/Justin.png" },
  { name: "Haruna Tijani Daniel (Mniqs,Rqs)", role: "Quantity Survey Manager", img: "/assets/img/Haruna.png" },
];

const TeamArea = () => {
  const sliderRef = useRef(null);
  const sectionRef = useRef(null);

  // Reset slider to first slide (CEO) when section enters viewport
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && sliderRef.current) {
            sliderRef.current.slickGoTo(0);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const settings = {
    ref: sliderRef,
    dots: false,
    infinite: true,
    speed: 800,
    cssEase: "ease-in-out",
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section
      className="space bg-auto"
      data-bg-src="assets/img/update1/bg/team_bg_3.png"
      id="team-sec"
      ref={sectionRef}
    >
      <style>{`
        .team-slider {
          position: relative;
        }
        .team-slider .slick-list {
          overflow: hidden;
          margin: 0 30px;
        }
        .team-card {
          background: #fff;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0,0,0,0.06);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          margin: 15px 10px;
          text-align: center;
        }
        .team-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.12);
        }
        .team-card .team-img {
          position: relative;
          overflow: hidden;
        }
        .team-card .team-img img {
          width: 100%;
          height: 320px;
          object-fit: cover;
          transition: transform 0.4s ease;
        }
        .team-card:hover .team-img img {
          transform: scale(1.05);
        }
        .team-card .team-content {
          padding: 20px 15px 10px;
          position: relative;
        }
        .team-card .team-title {
          font-size: 1.2rem;
          font-weight: 700;
          color: #0a1a3d;
          margin-bottom: 0.5rem;
        }
        .team-card .team-role {
          font-size: 0.95rem;
          color: #666;
          font-weight: 500;
          margin-bottom: 0.5rem;
        }

        .team-card .team-social {
          display: flex;
          justify-content: center;
          gap: 15px;
          opacity: 0;
          transition: opacity 0.3s ease;
          margin-top: 10px;
        }
        .team-card:hover .team-social {
          opacity: 1;
        }
        .team-card .team-social a {
          color: #0a1a3d;
          font-size: 1.1rem;
          transition: color 0.2s;
        }
        .team-card .team-social a:hover {
          color: #e86b24;
        }

        .ceo-card {
          border: 2px solid #e86b24;
          transform: scale(1.05);
          z-index: 1;
        }
        .ceo-card:hover {
          transform: scale(1.08);
        }
        .ceo-card .team-title {
          color: #e86b24;
          font-size: 1.4rem;
        }

        /* Hide any leftover default arrow text */
        .slick-prev:before,
        .slick-next:before {
          display: none !important;
        }

        @media (max-width: 768px) {
          .team-slider .slick-list {
            margin: 0 20px;
          }
          .team-card .team-img img {
            height: 280px;
          }
          .ceo-card {
            transform: none;
          }
        }
      `}</style>

      <div className="container">
        <div className="title-area text-center">
          <span className="sub-title6 justify-content-center">
            <span className="shape left"><span className="dots"></span></span>
            Team Members
            <span className="shape right"><span className="dots"></span></span>
          </span>
          <h2 className="sec-title">Our Professional Team</h2>
        </div>
        <div className="team-slider">
          <Slider {...settings}>
            {teamMembers.map((member, index) => {
              const isCEO = member.role.includes("CEO");
              return (
                <div key={index}>
                  <div className={`team-card${isCEO ? " ceo-card" : ""}`}>
                    <div className="team-img">
                      <img
                        src={member.img}
                        alt={member.name}
                        onError={(e) =>
                          (e.target.src = "/assets/img/team/default.jpg")
                        }
                      />
                    </div>
                    <div className="team-content">
                      <h3 className="team-title">{member.name}</h3>
                      <p className="team-role">{member.role}</p>
                      <div className="team-social">
                        <a target="_blank" href="https://facebook.com/" rel="noreferrer">
                          <i className="fab fa-facebook-f"></i>
                        </a>
                        <a target="_blank" href="https://twitter.com/" rel="noreferrer">
                          <i className="fab fa-twitter"></i>
                        </a>
                        <a target="_blank" href="https://linkedin.com/" rel="noreferrer">
                          <i className="fab fa-linkedin-in"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default TeamArea;